import { render } from "./WalletButtons.vue?vue&type=template&id=f7525e70"
import script from "./WalletButtons.vue?vue&type=script&setup=true&lang=js"
export * from "./WalletButtons.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"scripts/dashboard/WalletButtons.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f7525e70"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f7525e70', __exports__)) {
    api.reload('f7525e70', __exports__)
  }
  
  module.hot.accept("./WalletButtons.vue?vue&type=template&id=f7525e70", () => {
    api.rerender('f7525e70', render)
  })

}


export default __exports__